import { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { ChevronRightOutlinedIcon, FolderOutlinedIcon, truncateTextWithEllipsis } from '@utilities';

import styles from './_index.module.scss';

const Attributes = ({ activeAttribute, attributes = [], setActiveAttribute }) => {
  const userData = useSelector((state) => state?.user?.data);
  const [regularAttributes, customAttributes, fixedCustomAttributes] = useMemo(() => {
    const regular = [];
    const custom = [];
    const fixedCustom = [];
    attributes?.forEach((attr) => {
      if (attr?.isCustom && !attr?.isFixed) {
        custom.push(attr);
      } else if (attr?.isCustom && attr?.isFixed) {
        fixedCustom.push(attr);
      } else {
        regular.push(attr);
      }
    });
    return [regular, custom, fixedCustom];
  }, [attributes]);

  const renderCards = (list) =>
    list?.map((attribute, index) => {
      const isActive = activeAttribute?.id === attribute?.id;
      const attributeName = truncateTextWithEllipsis({
        length: 28,
        text: attribute?.name,
      });

      return (
        <div
          className={classNames(styles['attribute-card'], {
            [styles['is-active']]: isActive,
          })}
          key={attribute?.id ?? index}
          onClick={() => setActiveAttribute(attribute)}
          role="button"
          tabIndex={0}
          title={attribute?.name}
        >
          <FolderOutlinedIcon />
          <p>{attributeName}</p>
          <ChevronRightOutlinedIcon />
        </div>
      );
    });

  return (
    <div className={styles['attributes']}>
      {renderCards(regularAttributes)}
      {fixedCustomAttributes.length > 0 && (
        <>
          <h4>{`${userData?.clientInfo?.name} Hierarchy`}</h4>
          {renderCards(fixedCustomAttributes)}
        </>
      )}
      {customAttributes.length > 0 && (
        <>
          <h4>User Custom Groups</h4>
          {renderCards(customAttributes)}
        </>
      )}
    </div>
  );
};

Attributes.propTypes = {
  activeAttribute: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }),
  attributes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isCustom: PropTypes.bool,
      name: PropTypes.string.isRequired,
    })
  ),
  setActiveAttribute: PropTypes.func.isRequired,
};

export default Attributes;
